export default {
    en: require('./en.json'),
    zh_TW: require('./zh_TW.json'),
}
